module.exports = __webpack_public_path__ + "static/media/pizza.ef773329.svg";